import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "./constants";

const useGetCampaignById = (id) => {
  const [campaignData, setCampaignData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/creator/campaign/${id}`, {
        headers: {
          "auth-token": token,
        },
      });
      setCampaignData(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(error || "Internal Server Error");
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const refreshData = async () => {
    await getData(true);
  };

  return [campaignData, refreshData, isLoading];
};

export default useGetCampaignById;
